import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a6791be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a6791be&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6791be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a6791be')) {
      api.createRecord('6a6791be', component.options)
    } else {
      api.reload('6a6791be', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a6791be&scoped=true", function () {
      api.rerender('6a6791be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/order/index.vue"
export default component.exports